import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class TradingVaults extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/trading_vaults`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.tradingVaults.forEach((p: any) => this.processRecord(p)))
    );
  }

  get(id: any) {
    return this.api.get(id).pipe(
      tap((json) => this.processRecord(json.tradingVault))
    );
  }

  private processRecord(record: any) {
    record.reservedRate = new BigNumber(record.reservedRate).fromDecimal();
    record.totalShares = new BigNumber(record.totalShares).fromDecimal();
    record.withdrawFeeRate = new BigNumber(record.withdrawFeeRate).fromDecimal();
    record.maxCapacity = new BigNumber(record.maxCapacity).fromDecimal();
  }
}
